// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { timeseriesSeriesId } from './TimeseriesSeries';
import { z } from 'zod';
export const timeseriesPoint1h = z.object({
    series_id: timeseriesSeriesId,
    bucket: z.date(),
    min_v: z.number().nullable(),
    max_v: z.number().nullable(),
    sum_v: z.number().nullable(),
    min_ts: z.date().nullable(),
    max_ts: z.date().nullable(),
    n: z.string(),
    nan_n: z.string(),
    gap_ts: z.date().nullable(),
});
//# sourceMappingURL=TimeseriesPoint1h.js.map